import api from "api/api";

export const getClientsListByBillingClientIdQuery = async ({ id, scope }) =>
  await api.get(
    `datatrack/billing_client?scope=${scope}&billing-client-id=${id}&order-by=created-at-desc`
  );

export const getHistoryBillingClientByClientIdQuery = async ({ id, scope }) =>
  await api.get(
    `datatrack/billing_client?scope=${scope}&client-id=${id}&order-by=created-at-desc`
  );

export const createClientByBillingClientIdQuery = async ({ data, scope }) =>
  await api.post(`/datatrack/billing_client?scope=${scope}`, data);

export const editClientByBillingClientIdQuery = async ({ id, data, scope }) =>
  await api.put(`/datatrack/billing_client/${id}?scope=${scope}`, data);

export const deleteClientByBillingClientIdQuery = async ({ id, scope }) =>
  await api.delete(`/datatrack/billing_client/${id}?scope=${scope}`);
